import { type ICreateResultFlag, type IResultFlag, type IResultFlags } from '@/helpers/types';

import { coreApiSlice } from '../apiSlice';

export const resultFlagCoreApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getResultFlag: builder.query<IResultFlags, undefined>({
			query: () => '/ResultFlag',
		}),
		getResultFlagById: builder.query<IResultFlag, { id: string }>({
			query: ({ id }) => `/ResultFlag/${id}`,
		}),
		addResultFlag: builder.mutation<ICreateResultFlag, { name: string; description?: string }>({
			query: (body) => ({
				url: '/ResultFlag',
				method: 'POST',
				body,
			}),
		}),
		updateResultFlagById: builder.mutation<unknown, { id: string; name: string }>({
			query: ({ id, name }) => ({
				url: `/ResultFlag/${id}`,
				method: 'PUT',
				body: { id, name },
			}),
		}),
		deleteResultFlagById: builder.mutation<unknown, { id: string }>({
			query: ({ id }) => ({
				url: `/ResultFlag/${id}`,
				method: 'DELETE',
			}),
		}),
	}),
});

export const {
	useLazyGetResultFlagQuery,
	useLazyGetResultFlagByIdQuery,
	useAddResultFlagMutation,
	useUpdateResultFlagByIdMutation,
	useDeleteResultFlagByIdMutation,
} = resultFlagCoreApiSlice;
